var map = {
	"./app.json": 93685,
	"./blog.json": 44998,
	"./components.json": 2722,
	"./contratos.json": 84035,
	"./conversionTable.json": 63050,
	"./currency.json": 31781,
	"./currencyBRL.json": 16799,
	"./currencyUSD.json": 93603,
	"./cxi-old.json": 6288,
	"./cxi.json": 14312,
	"./events.json": 99487,
	"./form.json": 7900,
	"./glossary.json": 92042,
	"./home.json": 34985,
	"./iframe.json": 97494,
	"./login.json": 12143,
	"./logout.json": 69084,
	"./matches.json": 30155,
	"./menu.json": 26937,
	"./news.json": 20889,
	"./notifications.json": 57610,
	"./oiweek.json": 4650,
	"./pages.json": 30378,
	"./profile.json": 46103,
	"./ranking-BKP.json": 45920,
	"./ranking.json": 40404,
	"./register.json": 98819,
	"./startup-cxi.json": 79988,
	"./startup.json": 30887,
	"./startupId.json": 5134,
	"./support.json": 18781,
	"./translation.json": 29737,
	"translations/en/app.json": 93685,
	"translations/en/blog.json": 44998,
	"translations/en/components.json": 2722,
	"translations/en/contratos.json": 84035,
	"translations/en/conversionTable.json": 63050,
	"translations/en/currency.json": 31781,
	"translations/en/currencyBRL.json": 16799,
	"translations/en/currencyUSD.json": 93603,
	"translations/en/cxi-old.json": 6288,
	"translations/en/cxi.json": 14312,
	"translations/en/events.json": 99487,
	"translations/en/form.json": 7900,
	"translations/en/glossary.json": 92042,
	"translations/en/home.json": 34985,
	"translations/en/iframe.json": 97494,
	"translations/en/login.json": 12143,
	"translations/en/logout.json": 69084,
	"translations/en/matches.json": 30155,
	"translations/en/menu.json": 26937,
	"translations/en/news.json": 20889,
	"translations/en/notifications.json": 57610,
	"translations/en/oiweek.json": 4650,
	"translations/en/pages.json": 30378,
	"translations/en/profile.json": 46103,
	"translations/en/ranking-BKP.json": 45920,
	"translations/en/ranking.json": 40404,
	"translations/en/register.json": 98819,
	"translations/en/startup-cxi.json": 79988,
	"translations/en/startup.json": 30887,
	"translations/en/startupId.json": 5134,
	"translations/en/support.json": 18781,
	"translations/en/translation.json": 29737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47260;